import React, { useEffect, useState } from 'react';
import { getFiles } from '../../hooks/api-methods/get-upload';
import { deleteFile } from '../../hooks/api-methods/delete-upload';
import { Loader, Trash2 } from 'lucide-react';
import MyMasonry from '../../componentsNew/Mansory/Mansory';
import ConfirmModal from '../../componentsNew/PopUps/ConfirmModal';

interface FileItem {
  name: string;
  url: string;
}

const UploadsView: React.FC = () => {
  const [files, setFiles] = useState<FileItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<FileItem | null>(null);

  async function fetchFiles() {
    try {
      setLoading(true);
      setError(null);
      const result = await getFiles('uploads');
      setFiles(result);
    } catch (err) {
      if (err instanceof Error) setError(err.message);
      else setError('Er is een onbekende fout opgetreden.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchFiles();
  }, []);

  // Open modal
  function confirmDelete(file: FileItem) {
    setSelectedFile(file);
    setShowModal(true);
  }

  // Confirm deletion
  async function handleConfirmDelete() {
    if (!selectedFile) return;
    try {
      setLoading(true);
      await deleteFile('uploads', selectedFile.name);
      await fetchFiles();
    } catch (error) {
      console.error(error);
      alert('Verwijderen mislukt.');
    } finally {
      setShowModal(false);
      setSelectedFile(null);
      setLoading(false);
    }
  }

  if (loading) return <Loader />;
  if (error) return <p className="flex-row-align justify-center w-100 vh-75">{error}</p>;
  if (files.length === 0) return <p className="w-100 vh-75">Geen bestanden gevonden.</p>;

  return (
    <div className="ptb-2 relative">
      <MyMasonry
        items={files}
        renderItem={(file: FileItem) => (
          <div key={file.url} className="colomn-4 relative group">
            {file.url.match(/\.(jpg|jpeg|png|gif)$/i) ? (
              <img className="w-100 slider-img" src={file.url.trim()} alt={file.name} />
            ) : (
              <a
                href={file.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline"
              >
                {file.name}
              </a>
            )}

            <button onClick={() => confirmDelete(file)} className="btn-delete">
              <Trash2 />
            </button>
          </div>
        )}
      />

      <ConfirmModal
        isOpen={showModal}
        title="Bestand verwijderen"
        message={`Weet je zeker dat je '${selectedFile?.name}' wilt verwijderen?`}
        onConfirm={handleConfirmDelete}
        onCancel={() => setShowModal(false)}
      />
    </div>
  );
};

export default UploadsView;
